// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"dadb8b27","633":"682cd769","816":"56410601"}[chunkId] + ".chunk.js";
};